import React from 'react'
import { t } from 'ttag'

import { SendTestsMessageModal } from 'components/modals/common/SendTestsMessageModal/SendTestsMessageModal'

export const SendTestsRemindersModal = ({
  candidates,
  deadline,
  name,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <SendTestsMessageModal
    title={t`Send reminder message`}
    subtitle={t`Reminder messages`}
    type="reminder"
    {...{ candidates, deadline, name, onCancel, onClose, onConfirm, isOpen }}
  />
)
